(function ($) {
	var bursaryTableHeights = function () {
		if ($('.accordion-content').css('display') == 'block') {
			var $patientHeights = new Array(),
				$studentHeights = new Array();

			$('#patient')
				.children('div')
				.each(function (i) {
					var $class = this.className,
						$height = $(this).outerHeight();
					$patientHeights[i] = { class: $class, height: $height };
				});
			$('#student')
				.children('div')
				.each(function (i) {
					var $class = this.className,
						$height = $(this).outerHeight();
					$studentHeights[i] = { class: $class, height: $height };
				});
			var $countPatient = $patientHeights.length,
				$countStudent = $studentHeights.length,
				$count = $countPatient > $countStudent ? $countPatient : $countStudent;

			for (var i = 0; i < $count; i++) {
				var $studentClass = $studentHeights[i].class,
					$studentHeight = $studentHeights[i].height,
					$patientClass = $patientHeights[i].class,
					$patientHeight = $patientHeights[i].height;

				if ($patientHeight > $studentHeight) {
					$('#student')
						.find('.' + $studentClass)
						.outerHeight($patientHeight);
					if ($studentClass == 'bursary-title') {
						$('.steps .step-title').outerHeight($patientHeight);
					} else {
						$('.steps')
							.find('.' + $studentClass)
							.outerHeight($patientHeight);
					}
				} else {
					$('#patient')
						.find('.' + $patientClass)
						.outerHeight($studentHeight);
					if ($patientClass == 'bursary-title') {
						$('.steps .step-title').outerHeight($studentHeight);
					} else {
						$('.steps')
							.find('.' + $patientClass)
							.outerHeight($studentHeight);
					}
				}
			}
		}
	};
	$(document).ready(bursaryTableHeights);
	var delay = (function () {
		var timer = 0;
		return function (callback, ms) {
			clearTimeout(timer);
			timer = setTimeout(callback, ms);
		};
	})();
	$(window).resize(function () {
		delay(function () {
			bursaryTableHeights();
		}, 100);
	});
})(jQuery);
